/**
 * Compile-time exhaustiveness check for discriminated unions.
 * If a new variant is added and not handled, TypeScript errors on assigning it to `never`.
 */
export function assertNever(value: never, message?: string): never {
  throw new Error(message ?? `Unexpected value: ${String(value)}`);
}
